import React from "react";
import { SmallContainer } from "../Grid";

const DefaultContainer = props => (
  <SmallContainer>{props.children}</SmallContainer>
);

export default DefaultContainer;
